import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { LeaseForm, LeaseFormValues } from "../../components/lease-form";
import { Modal } from "../../components/modal";
import { formValuesToResidencyName } from "../../components/residency-name-input";
import { useAdditionalFields } from "../../hooks/addition-fields";
import { parseFormValuesToAdditionalFields } from "../../services/additional-fields";
import { createLease } from "../../services/lease";
import { navigateBack } from "../../utils/navigate-back";

export function LeaseCreate() {
  const navigate = useNavigate();
  const { data: additionalFields } = useAdditionalFields("lease");
  const queryClient = useQueryClient();

  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const [formValues, setFormValues] = useState<LeaseFormValues>({
    apartmentId: "",
    fromDate: "",
    toDate: "",
    useCustomName: false,
    customName: "",
    tenants: [
      {
        personId: "",
      },
    ],
    additionalFields: additionalFields.reduce(
      (acc, field) => ({
        ...acc,
        [field.name]: "",
      }),
      {},
    ),
  });

  const closeModal = () => {
    navigateBack(navigate, "/admin/register/lease");
  };

  return (
    <Modal open onClose={() => closeModal()}>
      <LeaseForm
        hasError={hasError}
        loading={loading}
        values={formValues}
        onCancel={() => closeModal()}
        onChange={setFormValues}
        onSubmit={() => {
          (async () => {
            setLoading(true);
            try {
              await createLease({
                apartmentId: formValues.apartmentId,
                tenants: formValues.tenants,
                fromDate: new Date(formValues.fromDate),
                toDate: formValues.toDate
                  ? new Date(formValues.toDate)
                  : undefined,
                customName: formValuesToResidencyName(formValues) ?? undefined,
                ...(formValues.additionalFields && {
                  additionalData: parseFormValuesToAdditionalFields(
                    formValues.additionalFields,
                    additionalFields,
                  ),
                }),
              });
              await queryClient.invalidateQueries({ queryKey: ["leases"] });
              closeModal();
            } catch (error: unknown) {
              setHasError(true);
            } finally {
              setLoading(false);
            }
          })();
        }}
      />
    </Modal>
  );
}
